import Button from '@material-ui/core/Button';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import React, { useEffect } from 'react';
import { getEnvVariable } from '../../../modules/environmentalList';
import { GetData } from '../helpers/requests';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

export default function CustomizedMenus(props) {
    //debugger
    const [anchorEl, setAnchorEl] = React.useState(null);
    const signOptions = getEnvVariable('AuthorizationLogins');
    // const params = useParams();
    const history = useHistory()

    useEffect(() => {
        if (window.location.hash.includes("resetpassword")) {
            let loc = history.location.pathname;
            let lastSlash = loc.lastIndexOf("/");
            let lastValue = loc.substring(lastSlash + 1);
            window.location.replace(getEnvVariable('AuthorizationScreen') + 'forgot/resetpassword?guid=' + lastValue + '&ENV=' + process.env.REACT_APP_PROFILE);
        }
    }, []);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRoute = (each) => {
        let url = getEnvVariable('Auth') + '/api/UserAuth/AuthType/' + getEnvVariable("AccessPortal");
        GetData(`${url}`).then(response => {
            if (response['OAuth'] === 'Y') {
                window.location.replace(each.AuthorizationPath + '&ENV=' + process.env.REACT_APP_PROFILE);
            }
        });
    };

    return (
        <div>
            {signOptions && signOptions.length === 1 ? (
                <Button
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    variant="contained" color="primary" style={{ width: '150px', textAlign: 'center' }}
                    onClick={() => handleRoute(signOptions[0])}
                >
                    {signOptions[0].Name}
                </Button>
            ) : (
                <>
                    <Button
                        aria-controls="customized-menu"
                        aria-haspopup="true"
                        style={{ color: 'inherit' }}
                        onClick={handleClick}
                    >
                        Sign In
                    </Button>
                    <StyledMenu
                        id="customized-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        {signOptions && signOptions.length > 0 && signOptions.map(each => (
                            <StyledMenuItem key={each.Name}>
                                <ListItemText primary={each.Name} onClick={() => handleRoute(each)} />
                            </StyledMenuItem>
                        ))}
                    </StyledMenu>
                </>
            )}
        </div>
    );
}